import { connect } from "react-redux"
import React, { useEffect, useState } from "react"
import { CustomerService, CustomerServiceList, Employee, EmployeeList } from "../../models";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { fetchEmployees } from "../../actions/employeeActionCreator.ts";
import moment from 'moment';
import { fetchServiceHistory } from "../../actions/customerActionCreator.ts";

interface ServiceIndexProps{
    isAuthenticated:boolean;
    employees:EmployeeList,
    getServices:(page:number,searchText:string)=>void;
    customerServices:CustomerServiceList;
}
const CustomerServiceIndex=(props:ServiceIndexProps)=>{
    const [count, setCount] = useState(10);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    let navigate = useNavigate();
    useEffect(()=>{
        if(!props.isAuthenticated){
            navigate("/login");
        }
    },[]);
    const submit = async () => {
        navigate("/customer-service-create");
    };
    const columns = [
        {
            label: "Name",
            prop: "customerName",
        },
        {
            label: "Mobile",
            prop: "customerPhone",
        },
        {
            label: "Service",
            prop: "service",
        },
        {
            label: "Amount",
            prop: "amount",
        },
        {
            label: "Status",
            prop: "serviceStatus",
        },
        {
            label: "Created By",
            prop: "createdBy",
        },
        {
            label: "Created On",
            prop: "createdOn",
        },
    ];
    const handlePageClick = (data: any) => {
        setPage(++data.selected);
    };

    useEffect(() => {
        props.getServices(page, searchText);
    }, [page]);

    useEffect(() => {
        //if(searchText.length>2){
        props.getServices(page, searchText);
        //}
    }, [searchText]);
    if (props.isAuthenticated) {
        return (
            <>
                <main className="">
                    <div className="studdash mt-4">
                        <div className="container">
                            <div className="card">
                                <div className="content-filter">
                                    <h2>Customer Services</h2>
                                    <div className="d-flex">
                                        <input type="text"
                                        placeholder="Search"
                                        onChange={e=>setSearchText(e.target.value)}
                                        value={searchText} />
                                        <a
                                            className="btn"
                                            href="javascript:void(0)"
                                            onClick={() => submit()}
                                        >
                                            Add New
                                        </a>
                                    </div>
                                </div>

                                <div className="mec-table">
                                    <table>
                                        <thead>
                                            <tr role="row">
                                                {columns
                                                    ? columns.map((c: any) => {
                                                        return <th>{c.label}</th>;
                                                    })
                                                    : null}
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        {props.customerServices?.data ? (
                                            props.customerServices?.data.length > 0 ? (
                                                <tbody id="filterinfo">
                                                    {props.customerServices
                                                        ? props.customerServices?.data.map(
                                                            (c: CustomerService) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{c.customerName}</td>
                                                                            <td>
                                                                                {c.customerPhone}
                                                                            </td>
                                                                            <td>{c.service}</td>
                                                                            <td>
                                                                                {c.amount}
                                                                            </td>
                                                                            <td>
                                                                                {c.serviceStatus==0?'Not Started':c.serviceStatus==1?'In Progress':'Completed'}
                                                                            </td>
                                                                            <td>
                                                                                {c.createdBy}
                                                                            </td>
                                                                            <td>{moment(c.createdOn).add(5, 'hour').add(30, 'minute').format("DD MMM YYYY hh:mm a")}</td>
                                                                            <td className="more">
                                                                                <h5 className="actions">

                                                                                    <button
                                                                                        className="btn-ico"
                                                                                        onClick={() => {
                                                                                            navigate(
                                                                                                "/customer-service-edit", { state: { id: c.id } }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <i className="fas fa-eye"></i>
                                                                                    </button>

                                                                                </h5>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            }
                                                        )
                                                        : null}
                                                </tbody>
                                            ) : (
                                                <p>No Data Found</p>
                                            )
                                        ) : null}
                                    </table>
                                </div>
                                {props.customerServices
                                    ? props.customerServices?.totalRecords
                                        ? props.customerServices?.totalRecords > count && (
                                            <ReactPaginate
                                                previousLabel={"←"}
                                                nextLabel={"→"}
                                                breakLabel={"..."}
                                                breakClassName={"break-me"}
                                                pageCount={
                                                    props.employees
                                                        ? Math.ceil(props.customerServices.totalRecords / 10)
                                                        : 1
                                                }
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                onPageChange={handlePageClick}
                                                containerClassName={"pagination"}
                                                activeClassName={"active"}
                                            />
                                        )
                                        : null
                                    : null}
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}

const mapDispatchToProps={
    getServices:(page:number,searchText:string)=>fetchServiceHistory(page,searchText)
}

function mapStateToProps(state:any){
    return{
        isAuthenticated:state.auth.isAuthenticated,
        employees:state.employee.employees,
        customerServices:state.customer.serviceHistory
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(CustomerServiceIndex)